import { Observable } from 'rxjs';

import { CartProductSearchRequest, CartProductSearchResponse } from '../../model/cart-administration.model';

export abstract class CartProductSearchAdapter {
  abstract searchProducts(
    request: CartProductSearchRequest
  ): Observable<CartProductSearchResponse>;
}
